import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { resendInvite } from './types';

import { requestResendInviteSuccess, requestResendInviteFailure } from './actions';

const logger = new Logger('Saga:Team:ResendInvite');

export function* requestResendInviteReducer(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    yield call(
      authApiService.put,
      routerService.generate('api.teams.resend_invite', { token: action.teamMemberId }),
    );

    yield put(requestResendInviteSuccess());
  } catch (error) {
    logger.error('Failed to resend invite with the following error', error);
    yield put(requestResendInviteFailure(error));
  }
}

export default function* resendInviteSaga() {
  return yield all([takeLatest(resendInvite.request, requestResendInviteReducer)]);
}
